import type { SocialLink } from "../../types";
import "./SocialLinks.css";

type SocialLinksProps = {
	links: SocialLink[];
};

/** Ícones sociais desenhados em SVG inline — sem dependência de icon font. */
export function SocialLinks({ links }: SocialLinksProps) {
	return (
		<ul className="social">
			{links.map((link) => (
				<li key={link.href}>
					<a href={link.href} target="_blank" rel="noreferrer">
						<SocialIcon icon={link.icon} />
						<span className="visually-hidden">{link.label}</span>
					</a>
				</li>
			))}
		</ul>
	);
}

function SocialIcon({ icon }: { icon: SocialLink["icon"] }) {
	const common = {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"aria-hidden": true,
		focusable: false,
	} as const;

	if (icon === "instagram") {
		return (
			<svg {...common} fill="none" stroke="currentColor" strokeWidth="1.8">
				<rect x="3" y="3" width="18" height="18" rx="5" />
				<circle cx="12" cy="12" r="4" />
				<circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
			</svg>
		);
	}

	if (icon === "linkedin") {
		return (
			<svg {...common} fill="currentColor">
				<path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.5 4.78 5.76V21h-4v-5.5c0-1.31-.03-3-1.9-3-1.9 0-2.2 1.42-2.2 2.9V21h-4V9Z" />
			</svg>
		);
	}

	if (icon === "bluesky") {
		return (
			<svg {...common} fill="currentColor">
				<path d="M12 10.8C10.9 8.5 7.9 4.4 5.3 3 3.4 2 2 2.6 2 4.9c0 1.4.8 5.8 1.3 6.5.9 1.4 2.5 1.6 4 1.3-2.6.4-3.3 1.9-1.9 3.4 2.6 2.9 4.2.7 5-1.1l1.6-4h.1l1.6 4c.8 1.8 2.4 4 5 1.1 1.4-1.5.7-3-1.9-3.4 1.5.3 3.1.1 4-1.3.5-.7 1.3-5.1 1.3-6.5 0-2.3-1.4-2.9-3.3-1.9-2.6 1.4-5.6 5.5-6.8 7.8Z" />
			</svg>
		);
	}

	return (
		<svg {...common} fill="currentColor">
			<path d="M13.5 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.25-1.5 1.55-1.5H16.7V3.6c-.3 0-1.3-.1-2.45-.1-2.42 0-4.08 1.48-4.08 4.2v2.2H7.5V13h2.67v8h3.33Z" />
		</svg>
	);
}
